import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ALL, DENIED } from "../../lib/consent/storage";
import { trackingHasStarted } from "../../lib/consent/runtime";
import { trapViewerFocus as trapDialogFocus } from "../viewer/focus";

export const ConsentPreferences = ({ categories, save, close }) => {
    const dialog = useRef(null);
    const [draft, setDraft] = useState(categories);
    useEffect(() => {
        const element = dialog.current;
        const opener = document.activeElement;
        const openerId = opener?.getAttribute("data-testid");
        const overflow = document.body.style.overflow;
        const stopped = window.__lenis?.isStopped;
        element.showModal(); window.__lenis?.stop(); document.body.style.overflow = "hidden";
        return () => {
            element.close(); document.body.style.overflow = overflow;
            if (!stopped) window.__lenis?.start();
            if (opener?.isConnected) opener.focus({ preventScroll: true });
            else if (openerId) document.querySelector(`[data-testid="${openerId}"]`)?.focus({ preventScroll: true });
        };
    }, []);
    return (
        <dialog ref={dialog} className="cookie-preferences" data-lenis-prevent data-testid="cookie-preferences-modal"
            onKeyDownCapture={trapDialogFocus}
            aria-labelledby="cookie-preferences-title" onCancel={(event) => { event.preventDefault(); close(); }}>
            <div className="cookie-preferences-head">
                <h2 id="cookie-preferences-title" data-testid="cookie-preferences-title">La scelta resta tua.</h2>
                <button type="button" className="cookie-close" onClick={close} aria-label="Chiudi senza modificare le preferenze" data-testid="cookie-preferences-close">×</button>
            </div>
            <p className="cookie-intro" data-testid="cookie-preferences-description">Nessun consenso è richiesto per inviarci una richiesta. Puoi cambiare idea quando vuoi.</p>
            {[
                { id: "necessary", label: "Necessari", text: "Preferenze cookie, tema e accesso all’area riservata. Sempre attivi." },
                { id: "analytics", label: "Statistiche", text: "Google Analytics 4, se configurato, per misurare visite e interazioni." },
                { id: "marketing", label: "Marketing", text: "Google Ads, Meta e TikTok, se configurati, per misurare campagne e richieste e personalizzare la pubblicità." },
            ].map(({ id, label, text }) => (
                <div className="cookie-category" key={id}>
                    <div><label htmlFor={`cookie-category-${id}`}>{label}</label><p data-testid={`cookie-description-${id}`}>{text}</p></div>
                    <input type="checkbox" role="switch" id={`cookie-category-${id}`} checked={id === "necessary" || draft[id]} disabled={id === "necessary"}
                        onChange={(event) => setDraft({ ...draft, [id]: event.target.checked })} data-testid={`cookie-toggle-${id}`} />
                </div>
            ))}
            <p className="cookie-fineprint">La scelta viene ricordata per 180 giorni. <Link to="/cookie" onClick={close} data-testid="cookie-preferences-policy">Informativa completa</Link>.</p>
            {trackingHasStarted() && <p className="cookie-fineprint" data-testid="cookie-reload-notice">La revoca ricarica la pagina per fermare i tag già avviati: i dati non inviati nei moduli non verranno conservati.</p>}
            <div className="cookie-actions cookie-preferences-actions">
                <button type="button" onClick={() => save(DENIED)} data-testid="cookie-preferences-reject">Rifiuta non necessari</button>
                <button type="button" onClick={() => save(ALL)} data-testid="cookie-preferences-accept">Accetta tutti</button>
                <button type="button" onClick={() => save(draft)} data-testid="cookie-preferences-save">Salva le scelte</button>
            </div>
        </dialog>
    );
};